import { render } from "./People.vue?vue&type=template&id=6e242c12&scoped=true"
import script from "./People.vue?vue&type=script&lang=js"
export * from "./People.vue?vue&type=script&lang=js"

import "@/assets/css/topicContent.sass?vue&type=style&index=0&id=6e242c12&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e242c12"]])

export default __exports__